import { DeliveryPreviewResponse } from 'src/api/getDeliveryPreview';

export const getDirectLink = ({
  uuid,
  responseURI = '',
  referral,
  env,
  deliveryPreview
}: {
  uuid?: UUID;
  responseURI?: string;
  referral?: string;
  env: ServerEnvironment;
  deliveryPreview: DeliveryPreviewResponse;
}): string => {
  let queryString = '?';

  if (uuid && !deliveryPreview?.deliveryID) {
    queryString += `uuid=${uuid}&`;
  }
  if (deliveryPreview?.deliveryID) {
    queryString += `delivery_id=${deliveryPreview.deliveryID}&`;
  }

  if (responseURI) {
    queryString += `redirect_url=${responseURI}&`;
  }
  if (referral) {
    queryString += `referral=${referral}`;
  }

  if (env === 'prod') {
    return `https://jump.nect.app/${queryString}`;
  }
  if (env === 'dev') {
    return `https://jump.dev.svc.nect.app/${queryString}`;
  }
  if (env === 'int') {
    return `https://jump.integration.svc.nect.app/${queryString}`;
  }
  return `https://test.jump.nect.app/${queryString}`;
};
